import { FC } from 'react';
import { BlockPage, BlockPageProps } from '../../../routings/pages/BlockPage/BlockPage';
import { Icons } from '@silverfort/sf-components';
import BlockPageMainImage from '../assets/BlockPageMainImage.png';

const topics: BlockPageProps['rightContent']['topics'] = [
    <span>Identify and match accounts to a singular identity</span>,
    <span>
        Bring your <span className="font-medium">tokens</span> and get <span className="font-medium">agentless</span>{' '}
        end-to-end MFA coverage everywhere
    </span>,
    <span>Create, define, and prioritize policies based on a variety of attributes and parameters</span>,
    <span>Scale a seamless logon experience for your users</span>
];

const UserManagementBlockPage: FC = () => {
    return (
        <BlockPage
            leftContent={{
                title: 'User Management for MFA',
                image: BlockPageMainImage
            }}
            rightContent={{
                topics,
                title: 'Unified Protection for Your Userbase',
                description: (
                    <span>
                        Enroll, manage, and safeguard all of your users in one place, with{' '}
                        <span className="font-medium">Universal MFA</span> protection.
                    </span>
                ),
                icon: Icons.UserEnrollment,
                accessLink: 'https://www.silverfort.com/mfa-signup/?utm_source=PQL&utm_content=main',
                badgeProps: {
                    text: 'License Upgrade',
                    color: 'positive'
                }
            }}
        />
    );
};

export default UserManagementBlockPage;
